/**
 * Leaving the app for a provider's hosted payment page. One seam, so tests can observe the redirect instead of
 * navigating jsdom away.
 */
export const external = {
  go(url: string) {
    window.location.assign(url);
  },
};
